import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { getObjectType } from '@cas/utils/translationHelpers';
import { BarChartByProps } from '../config';
import { ScenarioDataSetLabelV2, ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { saveFilters, setObjectTypes } from '@customer/store/slices/filtersSlice';
// import { isEnumValue } from "@customer/shared/utils/typeHelpers";
// import { VILevel, VIType } from "@customer/store/apis/interactionsApi";

// TODO: Re-enable the commented code after the UX for bar segment selection has been improved.

export const BarChartByObjectType = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const siteId = useAppSelector(state => state.auth.siteId);

  const getObjectTypeLabel = useCallback(
    (label: ScenarioDataSetLabelV2) => {
      return getObjectType(t, label.id);
    },
    [t],
  );

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ id: objectType }: CustomBarChartLabel): void => {
      if (siteId) {
        dispatch(setObjectTypes([objectType]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId],
  );

  // const onBarSelect = useCallback<OnBarSelect>(({ id: objectType }: CustomBarChartLabel, datasetId: string): void => {
  //   if (siteId) {
  //     dispatch(setObjectTypes([objectType]));

  //     // Also filter by VI type if the chart datasetId is a VILevel enum value.
  //     if (isEnumValue(datasetId, VILevel)) {
  //       const typesMatchingLevel: VIType[] = Object.values(VIType).filter((type: VIType) => type.endsWith(datasetId));
  //       dispatch(setVehicleInteractionTypes(typesMatchingLevel));
  //     }

  //     dispatch(saveFilters(siteId));
  //   }
  // }, [dispatch, siteId]);

  return (
    <BarChartScenario<T>
      {...props}
      getCategoryLabel={getObjectTypeLabel}
      onCategorySelect={onCategorySelect}
      // Temporarily use the same function for onBarSelect until the UX is improved.
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByObjectType;
